import React from 'react';
import { Wrapper, Tag } from './elements';

type ActTag01Props = {
  readonly className?: string;
  readonly tagOnClick?: () => void;
  readonly highlight?: boolean;
  readonly selected?: boolean;
  readonly children?: string;
};

export default function ActTag01({
  className,
  tagOnClick,
  highlight,
  selected,
  children,
}: ActTag01Props): React.ReactElement {
  return (
    <Wrapper
      className={className}
      onClick={tagOnClick}
      $highlight={highlight}
      $selected={selected}
    >
      <Tag>{`#${children}`}</Tag>
    </Wrapper>
  );
}
